import { CalendarPlus } from 'lucide-react';
import { useT } from '../../i18n';
import type { MeLink } from '../../lib/api/me';

/**
 * «AKTIVITETER HOS KLUBBEN» — the door on the CENTRE's home page (slice 4d,
 * 2026-10-21).
 *
 * The mirror of `PartnerCourtsCard`: drawn only from `/me`'s link reach for
 * the centre the portal is acting in — the clubs whose active co-operation
 * gave the centre `link.activity.manage` AND where this person holds
 * `activity.manage` at the centre (§4j 6A), the server's own rule, already
 * applied. Rendered only with a club to show.
 */
export function PartnerActivitiesCard({
  hosts,
  onOpen,
}: {
  hosts: MeLink[];
  onOpen: (host: MeLink) => void;
}) {
  const t = useT();
  return (
    <section
      className="max-w-6xl mx-auto px-4 md:px-6 pt-6"
      data-testid="partner-activities"
      aria-label={t('partnerActivities.title')}
    >
      <div className="card p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <p className="text-sm text-ink-2 inline-flex items-center gap-2">
          <CalendarPlus size={16} /> {t('partnerActivities.lead')}
        </p>
        <div className="flex flex-wrap gap-2">
          {hosts.map((h) => (
            <button
              key={`${h.linkId}:${h.homeTenantId}`}
              type="button"
              className="btn-outline text-xs"
              onClick={() => onOpen(h)}
              data-testid={`partner-activities-open-${h.hostSlug}`}
            >
              {t('partnerActivities.open', { club: h.hostName })}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
